import { Directive, createVNode, render, DirectiveBinding } from 'vue'
import FloatingMenuContent from '@/views/Editor/FloatingMenu/index.vue'

const CTX_Click_MENU_HANDLER = 'CTX_Click_MENU_HANDLER'

const clickListener = (el: HTMLElement, event: MouseEvent, binding: DirectiveBinding) => {
  if (event.button !== 0) return // 只处理左键点击事件
  
  // 阻止默认行为
  event.preventDefault()
  event.stopPropagation()
  // 获取自定义菜单数据
  const menus = binding.value(el)
  if (!menus) return
  if (menus.hide) return

  let container: HTMLDivElement | null = null
  // debugger
  // 移除菜单并取消相关的事件监听
  const removeContextmenu = () => {
    if (container) {
      document.body.removeChild(container)
      container = null
    }
    el.classList.remove('clickmenu-active')
    document.body.removeEventListener('scroll', removeContextmenu)
    window.removeEventListener('resize', removeContextmenu)
  }

  // 创建自定义菜单
  const options = {
    axis: { x: event.clientX, y: event.clientY },
    el,
    menus,
    removeContextmenu,
  }
  container = document.createElement('div')
  // 创建并渲染菜单组件
  const vm = createVNode(FloatingMenuContent, options, null)
  render(vm, container)
  document.body.appendChild(container)

  // 为目标节点添加菜单激活状态的className
  el.classList.add('clickmenu-active')

  // 页面变化时移除菜单
  document.body.addEventListener('scroll', removeContextmenu)
  window.addEventListener('resize', removeContextmenu)

}

const ClickMenuDirective: Directive = {
  mounted(el: HTMLElement, binding) {
    el[CTX_Click_MENU_HANDLER] = (event: MouseEvent) => clickListener(el, event, binding)
    el.addEventListener('click', el[CTX_Click_MENU_HANDLER])
  },
  
  unmounted(el: HTMLElement) {
    if (el[CTX_Click_MENU_HANDLER]) {
      el.removeEventListener('click', el[CTX_Click_MENU_HANDLER])
      delete el[CTX_Click_MENU_HANDLER]
    }
  },
}

export default ClickMenuDirective